import { render, staticRenderFns } from "./DetalleCotizacion.vue?vue&type=template&id=3838b6bc"
import script from "./DetalleCotizacion.vue?vue&type=script&lang=js"
export * from "./DetalleCotizacion.vue?vue&type=script&lang=js"
import style0 from "./DetalleCotizacion.vue?vue&type=style&index=0&id=3838b6bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports